import { connect } from 'react-redux'
import { showModal } from 'redux/modules/modals'
import AdminCustomersComponent from '../components/AdminCustomersComponent'

const mapActionCreators = {
  showModal
}

const mapStateToProps = state => {
  return {
    customers: state.customers.list
  }
}

export default connect(mapStateToProps, mapActionCreators)(
  AdminCustomersComponent
)



// WEBPACK FOOTER //
// ./src/routes/Admin/Customers/containers/AdminCustomersContainer.js